// @ts-nocheck
import { css } from 'styled-components';

interface BreakpointTypes {
  [key: string]: number;
  desktopXXL: number;
  desktopXL: number;
  desktop: number;
  tablet: number;
  mobile: number;
  smallphones: number;
}

export const breakpoints: BreakpointTypes = {
  desktopXXL: 1600,
  desktopXL: 1220,
  desktop: 992,
  tablet: 768,
  mobile: 576,
  smallphones: 321,
};

// Min-width
export const min = Object.keys(breakpoints).reduce((acc: any, label: string) => {
  acc[label] = (...args: any[]) => css`
    @media (min-width: ${breakpoints[label] / 16}em) {
      ${css.call(undefined, ...args)}
    }
  `;

  return acc;
}, {});

// Max-width
export const max = Object.keys(breakpoints).reduce((acc: any, label: string) => {
  acc[label] = (...args: any[]) => css`
    @media (max-width: ${(breakpoints[label] - 1) / 16}em) {
      ${css.call(undefined, ...args)}
    }
  `;

  return acc;
}, {});
